

const state = {
  batteryList:"",
}
function  init() {
  state.batteryList=JSON.parse( localStorage.getItem("batteryList"));
}
init();
const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      localStorage.setItem(key,JSON.stringify(value));
      state[key] = value
    }
  }

}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/column.js